import dayjs from 'dayjs';

export const sortRange = (range: [string, string?]): [string, string] => {
  const [from, to] = range;

  if (to === undefined) {
    return [from, from];
  }

  const [safeFrom, safeTo] = [from, to].sort((a, b) => (dayjs(a).isAfter(dayjs(b)) ? 1 : -1));
  return [safeFrom, safeTo];
};

export const getMonthDiff = (from: string, to: string) => {
  const fromDate = dayjs(from).set('date', 1);
  const toDate = dayjs(to);
  return toDate.diff(fromDate, 'month');
};

export const getRangeMonths = (
  [from, to]: [string, string],
  format: string = 'YYYY-MM-DD',
): string[] =>
  Array.from({ length: getMonthDiff(from, to) + 1 }).map((_, index) =>
    dayjs(from).set('date', 1).add(index, 'month').format(format),
  );

export interface MonthOptionType {
  year: number;
  month: number;
  label?: string;
}
export const toMonthOption = (dateText: string): MonthOptionType => {
  const date = dayjs(dateText);
  return {
    year: date.year(),
    // NOTE: dayjs의 month는 0-11 사이의 값을 반환
    month: date.month() + 1,
    label: date.isValid() ? date.format('YYYY.MM') : undefined,
  };
};
